module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-database-5.c307a17b.svg";